module.exports = __webpack_public_path__ + "d03a654c1fea73783748790104a97dc6.png";